/* eslint no-shadow: "off", no-param-reassign: ["error", { "props": false }], no-console: "off", quotes: "off" */

import store from '../store';
// eslint-disable-next-line
import localForage from '../../static/localforage.min.js';

const configPushRedirectionUrl = () => {
  localForage.setItem('redirectionUrl', window.location.origin);
};

const urlB64ToUint8Array = (base64String) => {
  /* eslint-disable */
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
  /* eslint-enable */
};

const subscribeUserForPushNotifications = (swReg) => {
  const appServerKey = urlB64ToUint8Array(store.getters['common/getPushNotificationsPublicKey']);
  swReg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: appServerKey,
  }).then((sub) => {
    console.log('User just subscribed for notifications! Sending the notification subscription json to server...');
    console.log(JSON.stringify(sub));
    store.dispatch('common/sendPushSubscriptionInfoToServer', sub);
  }).catch((err) => {
    console.log('Failed to subscribe the user for notifications: ', err);
  });
};

export const listenForPushNotifications = () => {
  configPushRedirectionUrl();
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    navigator.serviceWorker.register('/static/duel-push-notification-sw.js')
      .then((swReg) => {
        console.log('Push Notification Service Worker is registered', swReg);
        swReg.pushManager.getSubscription()
          .then((subscription) => {
            const isSubscribed = subscription !== null;
            if (isSubscribed) {
              console.log('User IS subscribed for notifications.');
              console.log(JSON.stringify(subscription));
              store.dispatch('profile/broadcastLogin');
            } else if (Notification.permission !== 'granted') {
              Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                  console.log('Permission for push notifications granted!');
                  subscribeUserForPushNotifications(swReg);
                }
              });
            } else {
              console.log('subscribing user for Push Notifications...');
              subscribeUserForPushNotifications(swReg);
            }
          });
      })
      .catch((error) => {
        console.error('Push Notifications Service Worker Error: ', error);
      });
  }
  console.warn('Push messaging is not supported');
};

const initCacheServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/duel-cache-service-worker.js', { scope: '/' }).then((reg) => {
      reg.onupdatefound = () => {
        const installingWorker = reg.installing;
        installingWorker.onstatechange = () => {
          switch (installingWorker.state) {
          case 'installed':
            if (navigator.serviceWorker.controller) {
              console.log('New or updated content is available.');
            } else {
              console.log('Content is now available offline!');
            }
            break;
          case 'redundant':
            console.error('The installing service worker became redundant.');
            break;
          default: break;
          }
        };
      };
    }).catch((e) => {
      console.error('Error during service worker registration:', e);
    });
  }
};

const registerServiceWorkers = () => {
  initCacheServiceWorker();
};

export default registerServiceWorkers;

/* eslint-enable */



// WEBPACK FOOTER //
// ./src/common/serviceWorkers.js